<template>
  <v-dialog v-model="$loja_consumidor.dialogExport" max-width="600">
    <v-card class="rounded-xl">
      <v-card-title class="d-flex justify-space-between">
        <h4>{{ $t("customers.export") }} {{ $t("customers.title") }}</h4>
        <v-btn icon @click="closeModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-card color="#f2f2f2" elevation="0" class="pa-2 rounded-lg">
          <h3>{{ $t("customers.export") }}:</h3>
          <v-radio-group v-model="exportar" mandatory>
            <v-radio
              :label="$t('customers.all-customers')"
              value="todos_consumidores"
            ></v-radio>
            <v-radio
              :label="
                $loja_consumidor.select_consumidores.length > 1
                  ? $t('customers.selected-plural') +
                    $loja_consumidor.select_consumidores.length +
                    ` ${$t('customers.title')}`
                  : $t('customers.selected') +
                    $loja_consumidor.select_consumidores.length +
                    ` ${$t('customers.customer')}`
              "
              value="selecionados"
            ></v-radio>
          </v-radio-group>
        </v-card>

        <v-card color="#f2f2f2" elevation="0" class="mt-4 pa-2 rounded-lg">
          <h3>{{ $t("customers.export-as") }}</h3>
          <v-radio-group v-model="exportationType" mandatory>
            <v-radio label="CSV" value="CSV"></v-radio>
          </v-radio-group>
        </v-card>
      </v-card-text>

      <v-card-actions class="justify-end pa-4">
        <v-btn @click="closeModal" color="primary" rounded outlined>
          {{ $t("customers.cancel") }}
        </v-btn>
        <v-btn @click="exportCustomers" color="primary" rounded>
          {{ $t("customers.export") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import LojaConsumidorMixins from "@/mixins/Loja-Consumidor.mixins.js";
export default {
  name: "ModalExportarConsumidor",
  mixins: [LojaConsumidorMixins],
  data() {
    return {
      exportar: "",
      exportationType: "CSV",
    };
  },
  computed: {
    customersIds() {
      return this.$loja_consumidor.select_consumidores.map(
        customer => customer.idconsumidor
      );
    },
  },
  methods: {
    exportCustomers() {
      this.$loja_consumidor.exportCustomers(
        this.exportar === "todos_consumidores" ? [] : this.customersIds,
        this.exportationType
      );
    },
    closeModal() {
      this.$loja_consumidor.dialogExport = false;
    },
  },
};
</script>

<style scoped></style>
